import Vue from 'vue'
import Vuex, {ModuleTree, StoreOptions} from 'vuex'
import {rootStore} from './types'
import {userState} from './modules/user'
import {rootState} from './modules/root'
import {modalState} from './modules/modal'
import {navigationState} from "./modules/navigation";
import {config} from "./modules/config";

Vue.use(Vuex);

const modules: ModuleTree<rootStore> = {
    user: userState,
    root: rootState,
    modal: modalState,
    navigation: navigationState,
    config: config
};

export default new Vuex.Store<StoreOptions<rootStore>>({
    modules
})
